import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": {}
}
/**
// const testFlag = {
//     "isAttachmentEnabled": true,
//     "isAudioAttachmentEnabled": true,
//     "isBlockEnabled": true,
//     "isClearChatEnabled": true,
//     "isDeleteChatEnabled": true,
//     "isDeleteMessageEnabled": true,
//     "isDocumentAttachmentEnabled": true,
//     "isGroupCallEnabled": true,
//     "isGroupChatEnabled": true,
//     "isImageAttachmentEnabled": true,
//     "isOneToOneCallEnabled": true,
//     "isRecentChatSearchEnabled": true,
//     "isReportEnabled": true,
//     "isStarMessageEnabled": true,
//     "isTranslationEnabled": true,
//     "isVideoAttachmentEnabled": true,
//     "isViewAllMediasEnabled": true,
// } 
*/
const addFeatureData = createSlice({
    name:'addFeatureData',
    initialState,
    reducers:{
        addFeatureList: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default addFeatureData.reducer
export const addFeatureList = addFeatureData.actions.addFeatureList